import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClipboardCopyService {

  copy(
    str: string,
  ): void {
    navigator.clipboard.writeText(str);
  }
}
